import { lazy } from 'react'

export const IntroVariant1 = lazy(() => import('./v1/IntroVariant1'))
export const IntroVariant3 = lazy(() => import('./v3/IntroVariant3'))
export const IntroVariant5 = lazy(() => import('./v5/IntroVariant5'))
export const IntroVariant8 = lazy(() => import('./v8/IntroVariant8'))
export const IntroVariant9 = lazy(() => import('./v9/IntroVariant9'))
export const IntroVariant10 = lazy(() => import('./v10/IntroVariant10'))
export const IntroVariant11 = lazy(() => import('./v11/IntroVariant11'))
